// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QsyCK","input":"styles_input__2-u3O"};